'use client';

import Link from 'next/link';
import { buttonVariants } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export function InviteOnlySignupContent() {
  return (
    <div className="space-y-6 text-center">
      <p className="text-sm text-muted-foreground leading-relaxed">
        The admin app is invite-only right now. If you received an invitation, use the link in your
        email to set your password, then sign in here.
      </p>
      <Link href="/login" className={cn(buttonVariants(), 'w-full')}>
        Sign in
      </Link>
      <p className="text-xs text-muted-foreground">
        Questions? Reach out to the person who shared Set Screen with you.
      </p>
    </div>
  );
}
